import border from '../../border';

const primary = (params) => border.hover.primary(params);

export default primary;
